module.exports = __webpack_public_path__ + "static/media/Highland Battler.331ab141.jpg";